import { Routes } from '@angular/router';
import { CmsPageComponent } from './pages/cms-page/cms-page.component';
import { cmsPageResolver } from './pages/cms-page/cms-page.resolver';

export const routes: Routes = [
  // UI Kit demo — must be before catch-all.
  // Lazy-loaded: foundation-demo is an internal-only design-system showcase
  // (~70 KiB raw). It is never on the LCP-critical path of any visitor, so
  // shipping it in main.js is pure waste. Splitting it out shrinks the
  // initial bundle dramatically.
  {
    path: 'ui-kit',
    loadComponent: () =>
      import('./pages/foundation-demo/foundation-demo.component').then(
        (m) => m.FoundationDemoComponent,
      ),
  },

  // Explicit 404 route (for programmatic navigation from resolver).
  // Lazy-loaded: the 404 page is a rare path and never reached on a first
  // visit. The few-KB chunk fetch on the unhappy path is acceptable; keeping
  // it eager would tax every other navigation forever.
  {
    path: '404',
    loadComponent: () =>
      import('./pages/not-found/not-found.component').then(
        (m) => m.NotFoundPageComponent,
      ),
  },

  // Home — root `/` resolves via Strapi to the `home` static-page.
  // Eager (NOT lazy): CmsPage is the entrypoint for ~99% of traffic — home
  // and every CMS-driven URL via the catch-all `**`. Lazy-loading would add
  // a chunk fetch to the LCP-critical path on first visit, which is the
  // opposite of the win we want.
  // Uses 'paramsOrQueryParamsChange' (not 'always') because pathMatch: 'full'
  // means only the exact URL '/' matches this route. Returning to '/' from
  // another route always re-activates the route regardless. 'always' would
  // redundantly re-run cmsPageResolver on fragment-only changes (e.g. ToC
  // anchors) and identical-URL re-navigations, hammering /api/resolve.
  {
    path: '',
    component: CmsPageComponent,
    resolve: { resolveResult: cmsPageResolver },
    runGuardsAndResolvers: 'paramsOrQueryParamsChange',
    pathMatch: 'full',
  },

  // CMS catch-all — any other path resolves via /api/resolve.
  // Eager (NOT lazy): same reasoning as the home route above.
  {
    path: '**',
    component: CmsPageComponent,
    resolve: { resolveResult: cmsPageResolver },
    runGuardsAndResolvers: 'always',
  },
];
